import * as React from 'react'
import { XIcon } from 'lucide-react'

import { cn } from '@/utilities/ui'

export const inputFocusClasses = cn(
  'ring-ring ring-offset-background transition-all outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
)

const Input: React.FC<
  {
    ref?: React.Ref<HTMLInputElement>
    IconComponent?: React.ComponentType<{ className?: string; size?: number }>
    onClear?: () => void
  } & React.InputHTMLAttributes<HTMLInputElement>
> = ({ type, className, ref, IconComponent, onClear, ...props }) => {
  return (
    <>
      <div className="relative max-xs:w-full">
        {IconComponent && (
          <IconComponent
            className="absolute top-1/2 left-3 -translate-y-1/2 text-muted-foreground"
            size={16}
          />
        )}
        <input
          className={cn(
            'flex w-full rounded-xl border border-border bg-input py-3 pr-3 font-family-body text-base text-primary file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:text-reg',
            inputFocusClasses,
            className,
            IconComponent ? 'pl-9' : 'pl-3',
          )}
          ref={ref}
          type={type}
          //need to hide the placeholder text when the input is focuse
          {...props}
        />
        {ref &&
          (() => {
            const handleClear = () => {
              if (ref && 'current' in ref && ref.current) {
                ref.current.value = ''
                ref.current.focus()
                onClear?.()
              }
            }
            const isClearable = Boolean(props.value && props.value.toString().trim() !== '')

            return (
              <button
                type="button"
                className={cn(
                  'absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-evergreen-500 focus-visible:ring-offset-0',
                  isClearable ? 'block' : 'hidden',
                  'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
                )}
                onClick={(e) => {
                  e.preventDefault()
                  handleClear()
                }}
                disabled={!isClearable}
                aria-label="Clear input"
              >
                <XIcon className="size-4 text-muted-foreground" />
              </button>
            )
          })()}
      </div>
    </>
  )
}

export { Input }
